import { useState, useEffect } from 'react';

const useTextSelection = () => {
  const [selection, setSelection] = useState('');

  useEffect(() => {
    if (!window || !document) {
      console.info('no shit');
      return;
    }

    const handleSelectionChange = () => {
      const activeSelection = document.getSelection();
      const text = activeSelection?.toString();

      if (!activeSelection || !text) {
        setSelection('');
        return;
      }

      setSelection(text);
    };

    document.addEventListener('selectionchange', handleSelectionChange);
    // eslint-disable-next-line consistent-return
    return () => {
      document.removeEventListener('selectionchange', handleSelectionChange);
    };
  }, []);

  return selection;
};

export default useTextSelection;
